import { TableRow } from "./ProcessTableUtils";
import { SQLGeneratedProcess } from "@avenueops/shared-types";
import { TableRow as AvenueTableRow } from "@avenueops/web-components";
import { Row } from "@tanstack/react-table";
import { useRouter } from "next/router";
import { ReactNode } from "react";
import { pagesPath } from "utils/$path";

interface Props {
  tableRow: Row<TableRow>;
  children: ReactNode;
  selectedProcess: SQLGeneratedProcess | null;
  setSelectedProcess: (_: SQLGeneratedProcess | null) => void;
}

export function ProcessTableRow({ tableRow, children, selectedProcess, setSelectedProcess }: Props): JSX.Element {
  const row = tableRow.original;
  const router = useRouter();

  return (
    <AvenueTableRow
      className={`divide-x`}
      data-state={selectedProcess?.id === row.id ? "selected" : ""}
      key={tableRow.id}
      onClick={() => {
        if (window.innerWidth < 768) {
          router.push(pagesPath.signals._id(row.id).$url());
        } else {
          setSelectedProcess(row);
        }
      }}
    >
      {children}
    </AvenueTableRow>
  );
}
